import axios from 'axios';

export default axios.create({
    headers: {
        withCredentials: true
    }
});
